import React, { useState } from 'react';
import cl from './FAQ.module.css';
import useReveal from '../../hooks/useReveal';

// Типичные вопросы руководителя детского центра.
// Сгруппированы по темам: продукт → продажа/преподаватели → деньги/документы → технические.
const faqs = [
    {
        q: 'Что входит в подписку?',
        a: 'Все три платформы (Майнкрафтия с 35 курсами, РобоТехника с 30 проектами электроники + 50 Arduino-проектами + 3D-редактором Кубикон CAD, админ-панель центра), 200 ученических аккаунтов, 5 учительских, доступ ко всему контенту (30 000+ задач с автопроверкой), Minecraft-серверы и обновления без доплат.',
    },
    {
        q: 'Подходит ли подросткам 14+?',
        a: 'Да. Для старших — Питон (2 курса на 5 400 задач), веб-разработка «Делаем сайт» (285 уроков HTML/CSS/JS), «Сервер в интернете» (Linux + Docker), «Бэкенд на Flask» (полная веб-разработка с проектами), Алгоритмы. Плюс подготовка к ОГЭ/ЕГЭ по математике. Уровень сложности от средней школы до 1 курса IT-вуза.',
    },
    {
        q: 'Подойдёт ли это для детей с нуля?',
        a: 'Да. Курсы рассчитаны от 5 лет (Подготовка к школе, дошкольная математика). С 7 лет начинают с Кубоши — нашего собственного редактора в стиле Scratch (8 курсов по 50 уроков). Дальше — Рублокс (наш 3D-конструктор-аналог Roblox), Питон, веб. Уровень нарастает плавно, никакого «прыжка в космос».',
    },
    {
        q: 'Нужны ли нам собственные преподаватели?',
        a: 'Базово не нужен инженер или программист. Достаточно обычного педагога — все уроки и задачи встроены в платформу, дети учатся самостоятельно, а сотрудник центра помогает в сложных местах и поддерживает атмосферу. Подготовить нового преподавателя обычно достаточно за 1–2 недели — он сам проходит курсы и читает наши статьи по интеграции.',
    },
    {
        q: 'Что если преподаватель уволится?',
        a: 'Программа не завязана на конкретном человеке. Новый преподаватель за 1–2 недели проходит курсы платформы сам — этого достаточно. Дети продолжают заниматься без перерыва: их аккаунты, прогресс, рейтинг сохраняются в облаке. Это одно из главных преимуществ нашей системы перед «авторскими» программами в центрах.',
    },
    {
        q: 'А если у меня уже свой Scratch и Roblox?',
        a: 'У нас есть собственные аналоги — <b>Кубоша</b> (Scratch-like редактор) и <b>Рублокс</b> (3D-конструктор как Roblox), полностью в браузере, без установки и регистрации в Roblox/MIT. Плюсы: всё на русском, автопроверка задач (в Scratch её нет), интеграция с журналом и рейтингом, общая подписка. Можно переходить плавно — со своего Scratch на Кубошу, например, с нового семестра.',
    },
    {
        q: 'Можно ли посмотреть платформу до оплаты?',
        a: 'Да, регистрация бесплатная. Сразу после неё открывается демо-доступ: 50 ученических аккаунтов и 5 курсов на пробу. Вы можете не торопясь оценить контент, прокликать уроки и задачи, посмотреть админ-панель. По желанию мы устроим персональный 15-минутный созвон-демо.',
    },
    {
        q: 'Можно ли пробный месяц?',
        a: 'Тариф «Помесячно» (25 000 ₽/мес) и есть формат пробы без обязательств — можно остановить в любой момент. Если центр хочет начать с одной группы и посмотреть, как пойдёт, — это лучший вариант.',
    },
    {
        q: 'Что делать, если у нас больше 200 учеников или 5 преподавателей?',
        a: 'Каждый дополнительный ученик — <b>1 000 ₽/мес</b>, каждый дополнительный преподаватель — <b>5 000 ₽/мес</b>. Подключаются в личном кабинете центра одним кликом. Если у вас сеть из нескольких центров — лицензия обсуждается индивидуально, обычно сильно выгоднее, чем брать отдельные подписки.',
    },
    {
        q: 'А что с оборудованием для робототехники?',
        a: 'Оборудование (паяльники, расходники, электроника, картон) центр закупает сам. Это не входит в подписку. Стартовый набор на группу 10 детей — ~50 000 ₽. У нас есть отдельная статья «Закуп под РобоТехнику» с полным списком и ссылками на Ozon/Амперо. Первые ~15 уроков можно делать на минимальном бюджете.',
    },
    {
        q: 'Какие документы вы предоставляете?',
        a: 'Счёт на оплату на ИП или ООО, договор оферты (публичный, на сайте), акт выполненных работ по итогам периода, закрывающие документы для бухгалтерии. Юр.лицо: <b>ИП Иванкова Виктория Сергеевна</b>, ИНН 233507286445, ОГРНИП 322237500039230.',
    },
    {
        q: 'Как происходит оплата?',
        a: 'По счёту на ваше ИП или ООО, переводом. Принимаем также карты и СБП через эквайринг <b>Тинькофф Касса</b> (АО «ТБанк»). После оплаты доступы выдаются в течение 1 рабочего дня.',
    },
    {
        q: 'Можно ли вернуть деньги, если не подойдёт?',
        a: 'Да. В первые 14 дней возвращаем 100% оплаты без вопросов. Дальше — пропорционально неиспользованным дням. Заявление направляется на maksimivankov26@yandex.ru.',
    },
    {
        q: 'Какие технические требования?',
        a: 'У ученика — компьютер или ноутбук (Windows, macOS, Linux), современный браузер (Chrome, Edge, Firefox), интернет 5+ Мбит/с. Никаких установок — всё работает в браузере, включая Кубошу, Рублокс, Питон-редактор. Дополнительно есть нативный плеер Кубикон 3D для Windows и Android (по желанию).',
    },
    {
        q: 'А если ребёнок захочет заниматься дома между занятиями?',
        a: 'Может. У каждого ученика свой личный кабинет и постоянный доступ ко всем курсам 24/7. Прогресс и рейтинг сохраняются в облаке. По нашей статистике дети, которые занимаются и дома, проходят курсы в 2–3 раза быстрее и в итоге дольше остаются в центре.',
    },
];

export default function FAQ() {
    const [open, setOpen] = useState(0);
    const revealRef = useReveal();

    return (
        <section className={cl.faq} id="faq" ref={revealRef}>
            <div className={cl.inner}>
                <div className={cl.head}>
                    <span className={cl.eyebrow} data-reveal="down">Часто спрашивают</span>
                    <h2 className={cl.title} data-reveal="up" style={{ '--reveal-delay': '100ms' }}>
                        Ответы на главные вопросы
                    </h2>
                    <p className={cl.subtitle} data-reveal="up" style={{ '--reveal-delay': '180ms' }}>
                        Если вашего вопроса нет — напишите на maksimivankov26@yandex.ru,
                        ответим в течение рабочего дня.
                    </p>
                </div>

                <div className={cl.list} data-reveal-stagger>
                    {faqs.map((f, i) => {
                        const isOpen = open === i;
                        return (
                            <div key={f.q} className={`${cl.item} ${isOpen ? cl.open : ''}`}
                                data-reveal={i % 2 === 0 ? 'left' : 'right'}>
                                <button type="button" className={cl.head_btn}
                                    onClick={() => setOpen(isOpen ? -1 : i)}
                                    aria-expanded={isOpen}>
                                    <span>{f.q}</span>
                                    <span className={cl.icon}>+</span>
                                </button>
                                {isOpen && (
                                    <div className={cl.answer}
                                        dangerouslySetInnerHTML={{ __html: f.a }}/>
                                )}
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
